import { point, featureCollection } from '@turf/helpers';

const pointItemToLngLat = item => {
  let lngLat;
  if (!item) {
    return null;
  }
  if (item._geoloc) {
    // Algolia Objects
    const loc = item._geoloc;
    lngLat = [loc.lng, loc.lat];
  } else if (item.location) {
    // AllTrails Objects
    const loc = item.location;
    lngLat = [loc.longitude, loc.latitude];
  } else if (item.latitude && item.longitude) {
    // Location Objects
    lngLat = [item.longitude, item.latitude];
  } else if (item.lngLat) {
    // Object with lngLat
    lngLat = item.lngLat;
  }
  if (lngLat && (lngLat[0] || lngLat[0] === 0) && (lngLat[1] || lngLat[1] === 0)) {
    if (lngLat[0] === 0 && lngLat[1] === 0) {
      // assume items with lat = 0 and lng = 0 have no location data
      return null;
    }

    return lngLat;
  }
  // N/A
  return null;
};

const pointItemToGeojson = item => {
  const lngLat = pointItemToLngLat(item);
  if (lngLat) {
    const { id, ID } = item;
    return point(lngLat, item, { id: id || ID });
  }
  // N/A
  return null;
};

const pointItemsToGeojson = items => {
  const geojsonPoints = [];
  items.forEach(item => {
    const p = pointItemToGeojson(item);
    if (p) {
      geojsonPoints.push(p);
    }
  });
  return featureCollection(geojsonPoints);
};

const extendBoundsByPointItem = (bounds, item) => {
  const lngLat = pointItemToLngLat(item);
  if (lngLat) {
    bounds.extend(lngLat);
  }
};

export { extendBoundsByPointItem, pointItemsToGeojson, pointItemToGeojson, pointItemToLngLat };
